// TrainingsDesk: eigene Trainer-Stammdaten (Plattform-Profil + Legacy-Deep-Links).

export const COACH_DESK_SELF_PROFILE_URL_SEGMENT = "meine-daten";
export const PLATFORM_PROFILE_TRAINER_SECTION = "trainer";

/**
 * @returns {string}
 */
export function buildCoachDeskSelfProfilePath() {
  return `/profile/${PLATFORM_PROFILE_TRAINER_SECTION}`;
}

/**
 * @param {string} pathname
 */
export function isCoachDeskSelfProfilePathname(pathname) {
  const parts = String(pathname || "")
    .split("?")[0]
    .split("/")
    .filter(Boolean);
  const root = parts[0] || "";
  const second = parts[1] || "";
  if (
    (root === "profile" || root === "account") &&
    second === PLATFORM_PROFILE_TRAINER_SECTION
  ) {
    return true;
  }
  const last = parts[parts.length - 1] || "";
  return (
    last === COACH_DESK_SELF_PROFILE_URL_SEGMENT ||
    last === "meine-profil" ||
    last === "my-profile"
  );
}

/**
 * Legacy TrainingsDesk-Pfad (/trainingsdesk/meine-daten …).
 *
 * @param {string} pathname
 */
export function isLegacyCoachDeskSelfProfilePathname(pathname) {
  const parts = String(pathname || "")
    .split("?")[0]
    .split("/")
    .filter(Boolean);
  const last = parts[parts.length - 1] || "";
  return (
    last === COACH_DESK_SELF_PROFILE_URL_SEGMENT ||
    last === "meine-profil" ||
    last === "my-profile"
  );
}

/**
 * @param {{ mode?: string, trainerId?: string }} input
 */
export function shouldShowCoachDeskSelfProfileAccountMenu({
  mode,
  trainerId,
} = {}) {
  const tid = String(trainerId || "").trim();
  if (!tid) return false;
  const m = String(mode || "").trim();
  return m === "trainer" || m === "coordinator";
}

/**
 * @param {object|null|undefined} trainerRow
 * @param {object[]} [bindings]
 */
export function shouldShowCoachDeskSelfProfileAccountMenuFromTrainer(
  trainerRow,
  bindings = [],
) {
  void bindings;
  const id = String(trainerRow?.id || "").trim();
  if (!id) return false;
  const loginRole = String(trainerRow?.login_role || "trainer").trim();
  if (loginRole === "planner") return false;
  return true;
}

/**
 * @param {{ trainerRow?: object|null, bindings?: object[], mode?: string, trainerId?: string }} [input]
 * @returns {string}
 */
export function resolveCoachDeskSelfProfileMenuHref({
  trainerRow,
  bindings,
  mode,
  trainerId,
} = {}) {
  if (shouldShowCoachDeskSelfProfileAccountMenu({ mode, trainerId })) {
    return buildCoachDeskSelfProfilePath();
  }
  if (
    !shouldShowCoachDeskSelfProfileAccountMenuFromTrainer(trainerRow, bindings)
  )
    return "";
  return buildCoachDeskSelfProfilePath();
}
